export const RouterPath = {
  root: "/",
  home: "pages/home/home",
  login: "pages/login/login",
  deviceInfo: "pages/device/device",
  thirdParty: "pages/commands/thirdApp",
  voiceCommand: "pages/commands/commands",
  compatibleDevice: "pages/commands/entry",
  serviceConnect: "pages/commands/connect",
  reset: "pages/reset/index",
  resetResult: "pages/reset/result",
  userTerms: "pages/policy/policy",
  privacy: "pages/privacy/privacy",
  productManual: "pages/instructions/instructions",
  helpCenterAlexa: "pages/commands/alexa",
  helpCenterGoogleHome: "pages/commands/googleHome",
  helpCenterDeleteAccount: "pages/deleteAccount/description",
  helpCenterAppleHealth: "pages/commands/applehealth",
  helpCenterGoogleFit: "pages/commands/googlefit",
  helpCenterHealthConnect: "pages/commands/healthconnect",
  lockShare: "pages/lock/share",
  download: "download",
  recipeDetail: "pages/index/index",

  //medcursor meter
  meterHistory: "pages/meter/history",
  meterDetails: "pages/meter/details",
  meterShare: "pages/meter/share",
  meterStatistics: "pages/meter/statistics",
};
